import { REACT_APP_SSO_URL } from '../utils/config';

const API_KEY = process.env.REACT_APP_API_KEY;
const SSO_URL = REACT_APP_SSO_URL;
const PASSWORD_REGEX = process.env.REACT_APP_PASSWORD_REGEX;
const SSO_LOGOUT_URL = `${REACT_APP_SSO_URL}/logout`;
export { API_KEY, PASSWORD_REGEX, SSO_URL, SSO_LOGOUT_URL };
